import SimpleBar  from './simplebar';

document.addEventListener("DOMContentLoaded", function () {
    (function () {
        var myElement = document.getElementById("simple-bar");
        new SimpleBar(myElement, {autoHide: true});
    })();
});